export default __webpack_public_path__ + "static/media/sad.6deb6819.png";